/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { LoaderLayout } from "components/atoms/loader/LoaderLayout";
import { useI18n } from "hooks/i18n/i18n";
import { BreadcrumbNavigation } from "ui/BreadcrumbNavigation";
import { SubContentsLayout } from "ui/SubContentsLayout";

import { HistoryList } from "./components/HistoryList";
import { ShowMoreButton } from "./components/ShowMoreButton";
import { FETCH_STATUS } from "./constants/fetchStatus";
import { contentsStyle, filterSelectStyle, heading2style } from "./styles";
import { useThis } from "./useThis";

import type { FC } from "react";

export const AccountSettlementHistoryV2: FC = () => {
  const { t } = useI18n();
  const {
    allHistoryCards,
    fetchStatus,
    handleLoadMore,
    handleSelectFilter,
    selectedFilter,
    settlementYearList,
    showLoadMore,
  } = useThis();

  if (fetchStatus === FETCH_STATUS.LOADING) {
    return (
      <div id="contents-layout">
        <LoaderLayout />
      </div>
    );
  }

  if (fetchStatus === FETCH_STATUS.ERROR) {
    return (
      <div id="contents-layout">
        <div css={contentsStyle}>{t("error.unknown")}</div>
      </div>
    );
  }

  return (
    <SubContentsLayout bgcolor={"GRAY"}>
      <BreadcrumbNavigation
        breadcrumbs={[
          { label: t("common.routes.home"), link: "/" },
          { label: t("common.routes.settlementHistory"), link: null },
        ]}
      />

      <div css={contentsStyle}>
        <h2 css={heading2style}>{t("common.routes.settlementHistory")}</h2>

        <select
          css={filterSelectStyle}
          name="filter"
          onChange={handleSelectFilter}
          value={selectedFilter}
        >
          <option value="last3Months">
            {t("settlementHistory.filterLast3Months")}
          </option>

          {selectedFilter !== "last3Months" &&
            !settlementYearList.some(
              (yearInfo) => String(yearInfo.year) === selectedFilter
            ) && (
              <option value={selectedFilter}>
                {selectedFilter}
                {t("settlementHistory.filterYearSuffix")} (0
                {t("settlementHistory.filterCountUnit")})
              </option>
            )}

          {settlementYearList.map((yearInfo) => (
            <option key={yearInfo.year} value={yearInfo.year}>
              {yearInfo.year}
              {t("settlementHistory.filterYearSuffix")} (
              {yearInfo.numOfSettlements}
              {t("settlementHistory.filterCountUnit")})
            </option>
          ))}
        </select>

        <HistoryList cards={allHistoryCards} />

        <ShowMoreButton
          isShown={showLoadMore}
          onClickShowMore={handleLoadMore}
        />
      </div>
    </SubContentsLayout>
  );
};
